import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CrossCircleSVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0C4.47 0 0 4.47 0 10s4.47 10 10 10 10-4.47 10-10S15.53 0 10 0zm4.3 14.3a.996.996 0 01-1.41 0L10 11.41 7.11 14.3a.996.996 0 11-1.41-1.41L8.59 10 5.7 7.11A.996.996 0 117.11 5.7L10 8.59l2.89-2.89a.996.996 0 111.41 1.41L11.41 10l2.89 2.89c.38.38.38 1.02 0 1.41z",
  fill: "#6B6B6B"
})));

export { CrossCircleSVG as default };
//# sourceMappingURL=bundle.esm2.js.map
